<div class="input-group">
  <ng-container *appHideIfNotInRole="['vessels-delivery-note-editor']">
    <button
      mat-stroked-button
      class="pull-right"
      (click)="addOil()"
      id="addButtonGroup">
      Add
    </button>
  </ng-container>
</div>